import { CreateCompany } from "../../types/companyTypes";
import baseApi from "../../utils/baseApi";

const SUPERADMIN_COMPANIES_API = "/superadmin/companies";
const SUPERADMIN_SPACES_API = "/superadmin/space/admin-space-list";

class SuperAdminCompanyService {
    static async getCompanyList () {
        try {
            const response = await baseApi.get(`${SUPERADMIN_COMPANIES_API}/list`);
            return response.data;
        } catch (error) {
            throw new Error("Failed to get company list.");
        }
    }

    static async getAdminSpaceList () {
        try {
            const response = await baseApi.get(`${SUPERADMIN_SPACES_API}`);
            return response.data;
        } catch (error) {
            throw new Error("Failed to get admin's space list.");
        }
    }

    static async createCompany (data:CreateCompany) {
        try {
            const response = await baseApi.post(`${SUPERADMIN_COMPANIES_API}`,data);
            return response.data;
        } catch (error) {
            throw new Error("Failed to add new company.");
        }
    }

    static async updateCompanyName (company_id: string, data:{company_name:string; status:string}) {
        try {
            const response = await baseApi.put(`${SUPERADMIN_COMPANIES_API}/${company_id}`,data);
            return response.data;
        } catch (error) {
            throw new Error("Failed to update company name.");
        }
    }

    static async deleteCompany (company_id: string) {
        try {
            const response = await baseApi.delete(`${SUPERADMIN_COMPANIES_API}/${company_id}`);
            return response.data;
        } catch (error) {
            throw new Error("Failed to delete company.");
        }
    }
}

export default SuperAdminCompanyService;
